import { SAVE_FORM_VALUES } from "../consts";

export function saveForm(idForm, values) {
  return { type: SAVE_FORM_VALUES, idForm: idForm, values: values };
}
